import ReactDOM from 'react-dom';
import React from 'react';
import BlackFridayFreePluginPopup from './popup';
import { getQueryString } from '../../../domain/url-provider';

export const BF_FREE_PLUGIN_QS_KEY = 'bfplugin';

/**
 * https://dev.waves.com/specials?bfplugin=free
 * https://dev.waves.com/my-recommended-products?bfplugin=free
 * https://dev.waves.com/specials?bfplugin=free#sort:path~type~order=.default-order~number~asc|views:view=grid-view|paging:currentPage=0|paging:number=18
 */
export const initBlackFridayFreePluginPopup = () => {
    if(window.location.pathname !== '/specials' && window.location.pathname !== '/my-recommended-products') return;

    const queryString = getQueryString(window.location.search);
    if(!queryString || queryString[BF_FREE_PLUGIN_QS_KEY] !== 'free') return;

    const $popup = document.getElementById('free-plugin-thank-you-popup');
    if (!$popup || !$popup.innerHTML) return;

    const $root = document.createElement('div');
    const width = Number($popup.getAttribute('data-width')) || 400;
    const height = Number($popup.getAttribute('data-height')) || 300;

    const closePopupCallback = () => {
        $root.remove();
    };

    ReactDOM.render(
        <BlackFridayFreePluginPopup
            popupHtml={ $popup.outerHTML }
            width={ width }
            height={ height }
            closePopupCallback={ closePopupCallback }
        />,
        $root
    );

    document.body.append($root);
};